import { render } from "./SectionSidebar.vue?vue&type=template&id=4ed667d5&scoped=true&ts=true"
import script from "./SectionSidebar.vue?vue&type=script&lang=ts"
export * from "./SectionSidebar.vue?vue&type=script&lang=ts"

import "./SectionSidebar.vue?vue&type=style&index=0&id=4ed667d5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ed667d5"]])

export default __exports__